export default __webpack_public_path__ + "static/android-icon-192x192-46c3bedb2be50b92199ab88e3cc9462a.png";